import { get } from 'lodash';
import { getFavouriteAccounts } from '../../states/favourites/selectors';

export const requestBodyForSetFavourites = (accounts) =>
	accounts.map((account) => ({
		display_order: get(account, 'metadata.display_order'),
		id: account.id,
	}));

export const removeFavouriteAccountRequestBody = (accountId, state) => {
	const favourites = getFavouriteAccounts(state);
	const removeFavouriteAccountList = favourites.filter((account) => account.id !== accountId);
	return JSON.stringify({
		accounts: requestBodyForSetFavourites(removeFavouriteAccountList),
	});
};
export const addFavouriteAccountRequestBody = (account, state) => {
	const favourites = getFavouriteAccounts(state);
	return JSON.stringify({
		accounts: requestBodyForSetFavourites([...favourites, account]),
	});
};
